import http from '../../../services/api'
import type { APIResponse, Filters, APIPaginatedResponse, Pagination } from '../../../services/types'
import { getRequestParamString } from '../../../services/utils/utils'
import { ITEM_GROUP } from '../../../constants/ItemGroup'
import type { ServiceType } from '../types'

const apiPath = import.meta.env.VITE_API_PATH

const SERVICE_ITEM_GROUP_ID = ITEM_GROUP.find((g) => g.name === 'Service')?.value

function resolveServiceTypeUuid(input: Pick<ServiceType, 'uuid'>): string {
  const uuid = input.uuid?.trim()
  if (!uuid) {
    throw new Error('Service type uuid is required')
  }
  return uuid
}

async function getServiceTypes(
  filters?: Partial<Filters>,
  pagination?: Partial<Pagination>,
  itemCategoryUuid?: string,
) {
  const paramString = getRequestParamString(filters, pagination)
  const parts: string[] = []
  if (SERVICE_ITEM_GROUP_ID != null) parts.push(`item_group_id=${SERVICE_ITEM_GROUP_ID}`)
  if (itemCategoryUuid) parts.push(`item_category_uuid=${encodeURIComponent(itemCategoryUuid)}`)
  const extraParams = parts.length ? (paramString ? '&' : '?') + parts.join('&') : ''
  return await http.get<APIPaginatedResponse<ServiceType>>(`${apiPath}items/item-types${paramString}${extraParams}`)
}

async function deleteServiceType(serviceTypeUuid: string) {
  return await http.delete<APIResponse<boolean>>(
    `${apiPath}items/item-types/${resolveServiceTypeUuid({ uuid: serviceTypeUuid })}`,
  )
}

async function createServiceType(input: ServiceType) {
  const payLoad = {
    name: input.name,
    item_category_uuid: input.item_category_uuid,
    description: input.description,
  }

  return await http.post<APIResponse<ServiceType>>(`${apiPath}items/item-types`, payLoad)
}

async function updateServiceType(input: ServiceType) {
  const payLoad = {
    name: input.name,
    item_category_uuid: input.item_category_uuid,
    description: input.description,
  }

  return await http.patch<APIResponse<ServiceType>>(
    `${apiPath}items/item-types/${resolveServiceTypeUuid(input)}`,
    payLoad,
  )
}

const serviceTypeService = {
  getServiceTypes,
  deleteServiceType,
  createServiceType,
  updateServiceType,
}

export default serviceTypeService
